module.exports = {
      id: "group-usage",
      viewBox: "0 0 11 10",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#group",
      toString: function () {
        return this.url;
      }
    }